export const REFERRAL_CODES_API_URL = 'ui/partner/referral_codes';

export const referralCodesQueryKeys = {
  all: [REFERRAL_CODES_API_URL],
};
